var _rect, _rect2, _rect3, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDescriptionImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 287,
    y: 67,
    width: 246,
    height: 466,
    rx: 33,
    fill: "#1DABF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 282,
    width: 200,
    height: 115,
    rx: 34,
    fill: "#1DABF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 418,
    width: 200,
    height: 115,
    rx: 34,
    fill: "#1DABF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.553 67H241.407C248.181 67.0081 254.676 69.6629 259.465 74.3818C264.255 79.1008 266.949 85.4986 266.956 92.1716V186.022L227.082 140.611C225.7 138.956 223.981 137.605 222.037 136.644C220.093 135.683 217.966 135.133 215.793 135.03C213.621 134.927 211.45 135.273 209.421 136.046C207.392 136.819 205.55 138.002 204.013 139.518L150.119 192.693L129.971 176.212C127.154 173.901 123.601 172.644 119.936 172.661C116.271 172.678 112.73 173.968 109.936 176.304L67 211.432V92.1716C67.0072 85.4979 69.7017 79.0995 74.4923 74.3805C79.2829 69.6614 85.7782 67.0071 92.553 67ZM114.168 142.465C118.838 145.539 124.327 147.181 129.943 147.181C137.472 147.173 144.691 144.224 150.015 138.98C155.339 133.736 158.334 126.626 158.343 119.209C158.343 113.677 156.678 108.269 153.558 103.669C150.438 99.069 146.003 95.4837 140.815 93.3664C135.626 91.2491 129.917 90.695 124.409 91.774C118.901 92.853 113.841 95.5167 109.869 99.4283C105.898 103.34 103.193 108.324 102.097 113.75C101.001 119.175 101.563 124.8 103.711 129.911C105.86 135.022 109.499 139.391 114.168 142.465ZM129.854 102.564C126.583 102.564 123.385 103.543 120.665 105.377C117.944 107.211 115.824 109.818 114.573 112.869C113.321 115.919 112.993 119.275 113.631 122.513C114.27 125.752 115.845 128.726 118.158 131.061C120.471 133.395 123.419 134.985 126.627 135.629C129.836 136.273 133.161 135.943 136.184 134.679C139.206 133.416 141.789 131.276 143.607 128.531C145.424 125.786 146.394 122.558 146.394 119.257C146.39 114.831 144.646 110.587 141.545 107.458C138.444 104.328 134.24 102.568 129.854 102.564ZM218.139 148.365L218.026 148.226C217.689 147.817 217.268 147.483 216.792 147.244C216.316 147.006 215.794 146.869 215.26 146.842C214.727 146.815 214.194 146.899 213.695 147.088C213.197 147.277 212.744 147.568 212.367 147.941L154.672 204.977C153.635 206.003 152.247 206.61 150.78 206.677C149.313 206.745 147.874 206.269 146.744 205.343L122.457 185.411C121.766 184.844 120.895 184.536 119.996 184.542C119.098 184.547 118.231 184.866 117.548 185.442L117.493 185.485L67 226.878V239.211C67.0103 245.894 69.7062 252.3 74.4964 257.025C79.2866 261.75 85.7802 264.407 92.553 264.415H241.403C248.178 264.407 254.674 261.748 259.464 257.021C264.255 252.294 266.949 245.884 266.956 239.199V204.102L218.139 148.365Z",
    fill: "#1DABF2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 95,
    width: 121,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 247,
    width: 121,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 209,
    width: 121,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 362,
    width: 121,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 95,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 247,
    width: 86,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 209,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 362,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 400,
    width: 213,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 133,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 438,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 285,
    width: 86,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 171,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 476,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 430,
    y: 323,
    width: 86,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 133,
    width: 85,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 438,
    width: 85,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 285,
    width: 85,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 171,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 476,
    width: 86,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 323,
    width: 86,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 133,
    width: 30,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 438,
    width: 30,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 486,
    y: 285,
    width: 30,
    height: 30,
    rx: 9,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 171,
    width: 29,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 476,
    width: 29,
    height: 29,
    rx: 9,
    fill: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 395,
    y: 323,
    width: 29,
    height: 30,
    rx: 9,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.085 513.799C196.492 515.21 198.392 516.005 200.374 516.011C201.403 516.12 202.443 516.014 203.429 515.699C204.416 515.383 205.327 514.866 206.108 514.18C206.229 514.066 206.346 513.947 206.459 513.826C207.826 512.348 208.557 510.381 208.491 508.358C208.425 506.335 207.568 504.422 206.108 503.038L179.324 476.101L206.107 449.007C207.322 447.506 207.925 445.595 207.796 443.66C207.667 441.725 206.815 439.912 205.413 438.59C204.011 437.268 202.164 436.535 200.247 436.541C198.33 436.547 196.487 437.291 195.093 438.621L168.653 465.37L141.682 438.245C140.239 436.995 138.382 436.342 136.483 436.416C134.585 436.49 132.784 437.287 131.44 438.646C130.097 440.005 129.31 441.827 129.236 443.748C129.163 445.669 129.809 447.547 131.045 449.007L157.936 476.213L131.045 503.419C129.64 504.849 128.852 506.783 128.852 508.799C128.852 510.815 129.64 512.75 131.045 514.18C132.528 515.47 134.449 516.127 136.402 516.011C138.329 516.107 140.219 515.451 141.682 514.18L168.574 486.976L195.085 513.799Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.301 302.717C215.446 301.856 214.43 301.172 213.312 300.706C212.195 300.24 210.996 300 209.786 300C208.576 300 207.378 300.24 206.26 300.706C205.142 301.172 204.127 301.856 203.271 302.717L157.663 348.613L142.585 333.439C140.845 331.763 138.522 330.839 136.114 330.866C133.705 330.892 131.403 331.867 129.7 333.58C127.996 335.294 127.028 337.611 127.001 340.035C126.974 342.459 127.891 344.797 129.555 346.548L144.633 361.723L151.152 368.283C152.007 369.144 153.023 369.828 154.141 370.294C155.259 370.76 156.458 371 157.668 371C158.878 371 160.076 370.76 161.194 370.294C162.312 369.828 163.328 369.144 164.184 368.283L216.301 315.828C217.157 314.967 217.836 313.945 218.299 312.821C218.762 311.696 219 310.49 219 309.273C219 308.055 218.762 306.849 218.299 305.725C217.836 304.6 217.157 303.578 216.301 302.717Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescriptionImage);
export default __webpack_public_path__ + "static/media/descriptionImage.e9a074df7d6d6b147dcaa341d54ef451.svg";
export { ForwardRef as ReactComponent };